const SPECIAL_CHARS = {
  TURKISH:
    '\u00C7\u00E7\u011E\u011F\u0130\u0131\u00D6\u00F6\u015E\u015F\u00DC\u00FC',
  SPANISH:
    '\u00D1\u00F1\u00C1\u00E1\u00C9\u00E9\u00CD\u00ED\u00D3\u00F3\u00DA\u00FA',
  PORTUGUESE: '\u00C3\u00E3\u00C7\u00E7\u00D5\u00F5',
  RUSSIAN:
    '\u0410-\u0419\u0430-\u0439\u0401\u0451\u041A-\u0429\u043A-\u0449\u042A-\u042F\u044A-\u044F',
};

export const REGEXP = {
  NAME: new RegExp(
    '^[a-zA-Z' +
      SPECIAL_CHARS.TURKISH +
      SPECIAL_CHARS.SPANISH +
      SPECIAL_CHARS.PORTUGUESE +
      SPECIAL_CHARS.RUSSIAN +
      ' ]*$'
  ),
  EMAIL:
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  ADDRESS: new RegExp(
    '^[a-zA-Z0-9' +
      SPECIAL_CHARS.TURKISH +
      SPECIAL_CHARS.SPANISH +
      SPECIAL_CHARS.PORTUGUESE +
      SPECIAL_CHARS.RUSSIAN +
      ' #;,./\\()&:-]*$'
  ),
  PASSWORD: new RegExp(
    '^[a-zA-Z0-9' + SPECIAL_CHARS.TURKISH + SPECIAL_CHARS.RUSSIAN + ']{6,12}$'
  ),
  PHONE: /^[0-9]*$/,
  POSTAL_CODE: /^[a-zA-Z0-9 -]{1,20}$/,
  CONTAINS_NUMBER: /^.*\d.*$/,
  NO_LETTERS: /^[^a-zA-Z]+$/,
  AT_LEAST_TWO_WORDS: '(\\w+)(\\s+)(\\w+)',
  LESSON_FORMAT_IN_TEXT: /[0-9]+.[0-9]+/g,
};
